<template>
  <div class="communityhot search">
    <div v-if="follow" style="height: 0.55rem;width: 100%"></div>
    <header class="community" :style="follow ? {'top': '0.45rem'} : {}">
      <div class="searchBox flex-ac">
        <div class="search flex-1 flex-ac" @click="goSearch">
          <div class="inp f13">请输入您想要的内容</div>
        </div>
        <div class="searchBtn f14" @click="goSearch"><van-icon name="search" color="#ffffff" size="0.2rem"/>搜索</div>
      </div>
      <!--      <form action="/">-->
      <!--        <van-search-->
      <!--          v-model="searchValue"-->
      <!--          placeholder="大家都在搜“小奶杯”"-->
      <!--          show-action-->
      <!--          clearable-->
      <!--          @search="search"-->
      <!--        >-->
      <!--          <template #action>-->
      <!--          </template>-->
      <!--        </van-search>-->
      <!--      </form>-->
      <!--      <button class="search" @click="goSearch"><img src="/static/images/community/search.png"></button>-->
    </header>
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="hot">
        <p class="flex-js-ac">
          <span class="f16 flex-ac">热门话题<img width="12" height="14" src="/static/images/community/community-icon-hot1@2x.png" alt=""></span>
          <span class="f13 red flex-ac" @click="$clickburiedPoint({data: {buttonCode: 'topicbutton'}, url: 'community/userbehavior/save'});$router.push('/topiclist')">话题广场<van-icon name="arrow" color="#FC0324"/></span>
        </p>
        <swiper id="hotSwiper" :options="hotSwiper">
          <swiper-slide v-for="(item, index) of subjectlist" :key="index">
            <img :src="item.img" @click="goList(item)">
            <span class="f12 over-ell-1" @click="goList(item)">{{item.subject}}</span>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" id="swiperPagination"></div>
      </div>
      <div class="zIndex">
        <van-tabs @change="tagsClick" v-model="tagsIndex" :ellipsis="false" sticky :offset-top="90" line-width="0.24rem" line-height="0.03rem" title-active-color="#FC0324" title-inactive-color="#333333">
          <van-tab :class="{'swiper-slide':true}" v-for="(item, index) in taglist" :name="index"
                   :title="item.name"
                   :key="index">
          </van-tab>
          <div class="list">
            <div class="listItem" ref="listItem1">
              <community-item v-for="(item, index) in list1" :prolistItem="item" :key="index"></community-item>
            </div>
            <div class="listItem" ref="listItem2">
              <community-item v-for="(item, index) in list2" :prolistItem="item" :key="index"></community-item>
            </div>
          </div>
        </van-tabs>
      </div>
    </Scroller>
    <div class="homeBtn">
      <div style="position:relative;height: 0.55rem;">
        <img class="release1" src="/static/images/community/release1.gif" @click="goRelease">
        <img class="release1" src="/static/images/community/release1.png" @click="goRelease">
      </div>
      <div style="position: relative;height: 0.55rem;">
        <img class="msg" v-if="msgnum<= 0" src="/static/images/community/msg.png" @click="goMsg">
        <div v-else class="msg floatBtn" @click="goMsg">
          <p class="number">{{msgnum> 99 ? '99+' : msgnum}}</p>
          <p>消息</p>
        </div>
      </div>
      <div class="floatBtn_new" style="position: static">
        <img v-if="newperson && newperson.isnewpersontask" @click="newpersontask" src="/static/images/new-person/newpersontask@2x.png">
      </div>
    </div>
<!--    <footer-comp :footer-index="index"></footer-comp>-->
  </div>
</template>

<script>
  // import communityHeader from '../common/communityHeader'
  // import footerComp from '../common/footerComp'
  import follow from '../common/follow'
  import Scroller from '../common/Scroller'
  import VueAwesomeSwiper from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.min.css'
  import communityItem from '../common/communityItem'
  import { isWeixin, fenxiang } from '../../assets/common/js/config'
  import Vue from 'vue'

  Vue.use(VueAwesomeSwiper /* { default global options } */)

  export default {
    name: 'communityIndex',
    props: {
      type: {
        type: String,
        default: ''
      },
      newperson: Object
    },
    components: {
      // communityHeader,
      // footerComp,
      follow,
      Scroller,
      communityItem
    },
    data: function () {
      return {
        index: 2,
        list1: [],
        list2: [],
        follow: true,
        nowPage: 0,
        refresh: false,
        loading: false,
        finished: false,
        msgnum: '',
        hotSwiper: {
          autoplay: false,
          autoplayDisableOnInteraction: false,
          slidesPerView: 3,
          slidesPerGroup: 3,
          observer: true,
          observeParents: true,
          spaceBetween: 10,
          pagination: {
            el: '#swiperPagination',
            type: 'bullets'
          }
        },
        subjectlist: [],
        taglist: [],
        tagsIndex: this.$store.state.communityTagsTab ? this.$store.state.communityTagsTab : 0

      }
    },
    mounted: function () {
      if (isWeixin()) fenxiang({path: 'communityindex'})
    },
    beforeRouteEnter (to, from, next) {
      if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) { // 当前页面刷新不需要切换位置
        sessionStorage.askPositon = ''
        next()
      } else {
        next(vm => {
          if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
            setTimeout(function () {
              window.scrollTo(0, sessionStorage.askPositon, false)
            }, 0) // 同步转异步操作
          }
        })
      }
    },
    beforeRouteLeave (to, from, next) { // 记录离开时的位置
      sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
      next()
    },
    methods: {
      async hotData (fn) {
        let url = 'Wxmall/CommunityPosts/getHotIndex'
        let {data} = await this.$customRequestAjax(url)
        this.subjectlist = data.subjectlist
        this.taglist = data.taglist
        this.msgnum = data.msgnum < 99 ? parseInt(data.msgnum) : (parseInt(data.msgnum) + '+')
        if (typeof fn == 'function') fn()
      },
      getData: function () {
        var that = this, tagitem = this.taglist[this.tagsIndex], tagid = '', type = 0
        type = tagitem.type
        if (tagitem.type == 1) {
          tagid = tagitem.id
        } else {
          tagid = tagitem.type == 0 ? '0' : (this.taglist.length - 1)
        }
        var url = 'Wxmall/CommunityPosts/getPostsByType'
        url= url + '?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&tagid=' + tagid + '&type=' + type
        this.$customRequestAjax(url)
          .then(function (res) {
            if (res.data.code == 200) {
              if (that.nowPage == 1) {
                that.$clickburiedPoint({
                  data: {
                    buttonCode: 'classtopic-' + tagid
                  },
                  url: 'community/userbehavior/save'
                })
                that.list1 = []
                that.list2 = []
                that.refresh = false
              }
              if (res.data.list.length < that.pagesize) {
                that.finished = true
                if (that.nowPage == 1 && !res.data.list.length) {
                  that.list1 = []
                  that.list2 = []
                }
              } else {
                that.finished = false
              }

              that.$nextTick(() => {
                setTimeout(() => {
                  that.doSort(0, res.data.list)
                }, 100)
              })
            }
          })
      },
      doSort (index, list) {
        let that = this
        if (!that.$refs.listItem1 || !that.$refs.listItem2) return
        if (index < list.length) {
          f()
          function f() {
            if (that.$refs.listItem1.clientHeight <= that.$refs.listItem2.clientHeight) {
              that.list1.push(list[index])
            } else {
              that.list2.push(list[index])
            }
            if (index < list.length - 1) {
              that.loading = true
            } else {
              that.loading = false
            }
            that.$nextTick(() => {
              setTimeout(() => {
                that.doSort(index + 1, list)
              }, 100)
            })
          }
        }
      },
      newpersontask () {
        window.location = this.newperson.newpersonjump
      },
      onRefresh () {
        this.refresh = true
        this.nowPage = 1
        this.hotData(() => this.getData())
      },
      onInfinite () {
        this.loading = true
        this.finished = false
        var that = this
        that.nowPage++
        if (that.nowPage == 1) {
          that.hotData(() => that.getData())
        } else {
          that.getData()
        }
      },
      goList: function (item) {
        if (item.url) {
          window.location = item.url
        } else {
          this.$router.push({
            path: '/communityfollow',
            query: {
              subjectid: item.id,
              subject: encodeURIComponent(item.subject)
            }
          })
        }
      },
      goSearch: function () {
        this.$router.push({
          path: '/communitysearch'
        })
      },
      followFn: function (data) {
        this.follow = data
      },
      goMsg: function () {
        this.msgnum = 0
        this.$router.push('/communitymsg')
      },
      tagsClick: function (id) {
        this.tagsIndex = id
        this.$store.commit('COMMUNITY_TAGS_TAB', this.tagsIndex)
        this.list1 = []
        this.list2 = []
        this.nowPage = 0
        this.onInfinite()
      },
      goRelease: function () {
        var that = this
        // 登录校验
        if (!isWeixin()) {
          if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
            this.$store.commit('PATH_VALUE', JSON.stringify({id: this.$route.query.id}))
            this.$router.push({
              path: '/login',
              query: {
                routeval: 'communitydetail'
              }
            })
          } else {
            f()
          }
        } else {
          f()
        }
        function f () {
          that.$clickburiedPoint({
            data: {
              buttonCode: 'posted'
            },
            url: 'community/userbehavior/save'
          })
          that.$router.push({
            path: '/communityevaluation'
          })
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .search {
    height: 100%;
  }
  header {
    position: fixed;
    top: 0.45rem;
    left: 0;
    right: 0;
    z-index: 10;
    background: #ffffff;
    .van-search {
      padding: 0 0.11rem;
    }
  }
  .hot {
    margin-bottom: 0.1rem;
    background: #ffffff;
    padding: 0.1rem 0.11rem 0.22rem;
    position: relative;
    p {
      font-size: 0;
      margin-bottom: 0.1rem;
      .red {
        color: #FC0324;
      }
    }
    .swiper-slide{
      font-size: 0;
      img {
        width: 100%;
        height: 0.56rem;
        margin-bottom: 0.05rem;
        border-radius: 0.04rem;
      }
      span {
        text-align: center;
      }
    }
  }
  .zIndex {
    /*background: #eeeeee;*/
    position: relative;
    /*z-index: 3;*/
  }
  .list {
    width: 100%;
    padding-right: 0.1rem;
    margin-top: 0.1rem;
    overflow: hidden;
    .listItem {
      padding-left: 0.1rem; // 剧中
      width: 50%;
      float: left;
    }
  }
  .homeBtn {
    background: transparent;
    z-index: 51;
    position: fixed;
    right: 0.16rem;
    bottom: 1.35rem;
    img {
      height: 0.55rem;
      margin-top: 0.1rem;
    }
    .floatBtn_new {
      img {
        width: 0.55rem;
      }
    }
    .release1,.msg {
      position: absolute;
      right: 0;
    }
    .release1 {
      width: auto;
      bottom: 0;
      height: 0.55rem;
    }
    .floatBtn {
      right: 0.06rem !important;
    }
  }
  .floatBtn {
    background: #ffffff;
    z-index: 51;
    width: 0.43rem;
    height: 0.43rem;
    border-radius: 0.21rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    margin-top: 0.1rem;
    margin-left: 0.02rem;
    p {
      font-size: 0.11rem;
      color: #444444;
      text-align: center;
      &.number {
        font-size: 0.12rem;
      }
    }
  }
</style>
<style lang="scss">
  .hot {
    #swiperPagination {
      width: auto;
      font-size: 0;
      color: #ffffff;
      /*right: 0.21rem;*/
      left: 50%;
      bottom: 0.11rem;
      transform: translateX(-50%);
      z-index: 1;
      span {
        &.swiper-pagination-bullet {
          width: 0.11rem;
          height: 0.02rem;
          border-radius: 0.01rem;
          margin-left: 0;
          background: #CCCCCC;
        }
        &.swiper-pagination-bullet-active {
          background: #FC0324;
        }
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
  .communityhot {
    .zIndex {
      .van-tab {
        font-weight: 500;
      }
      .van-tabs__line {
        bottom: 0.2rem;
      }
      .van-sticky--fixed {
        top: 0.87rem!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/community/communityHot.vue